module.exports = __webpack_public_path__ + "img/3.35b6b483.png";